import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  withStyles,
} from "@material-ui/core/styles";
import {
  Divider,
  TextField,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Checkbox,
  TablePagination,
} from "@material-ui/core";
import {
  getTatTests,
  getTatTestsNames,
  getLabCredential,
  updateTatTests,
  getCenterInfo,
} from "../../actions/GenomicsAdminAction";
import { connect } from "react-redux";
import Loader from "../../Components/loader/index";
import { useHistory } from "react-router";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "left",
      color: theme.palette.text.secondary,
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    disabled: {},
  })
);

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

interface SampleTransferProps {
  updateTatTests: any;

  getLabCredential: any;
  labCredential: any;
  getTatTests: any;
  tatTests: any;
  getTatTestsNames: any;
  tatTestsNames: any;
  getCenterInfo: any;
  centerInfo: any;
  loading: any;
}

const SampleRegistrationTATMaster: React.FC<SampleTransferProps> = ({
  updateTatTests,
  getLabCredential,
  labCredential,
  getTatTests,
  getTatTestsNames,
  tatTestsNames,
  tatTests,
  getCenterInfo,
  centerInfo,
  loading,
}) => {
  const classes = useStyles();

  const [lab, setLab] = React.useState("");
  const history = useHistory();
  const [update, setUpdate] = React.useState("");
  const [testId, setTestId] = React.useState<any>("");
  const [centre, setCentre] = useState<any>("");

  const [centreName, setCentreName] = useState<any>("");
  const [tableData, setTableData] = React.useState<any>("");
  const [departmentId, setDepartmentId] = React.useState<any>("");
  useEffect(() => {
    getCenterInfo();
    getLabCredential();
  }, []);
  function formatTime(timeInput: any) {
    let intValidNum = timeInput.value;

    if (intValidNum < 24 && intValidNum.length === 2) {
      timeInput.value = timeInput.value + ":";
      return false;
    }
    if (intValidNum === 24 && intValidNum.length === 2) {
      timeInput.value = timeInput.value.length - 2 + "0:";
      return false;
    }
    if (intValidNum > 24 && intValidNum.length === 2) {
      timeInput.value = "";
      return false;
    }

    if (intValidNum.length === 5 && intValidNum.slice(-2) < 60) {
      timeInput.value = timeInput.value + ":";
      return false;
    }
    if (intValidNum.length === 5 && intValidNum.slice(-2) > 60) {
      timeInput.value = timeInput.value.slice(0, 2) + ":";
      return false;
    }
    if (intValidNum.length === 5 && intValidNum.slice(-2) === 60) {
      timeInput.value = timeInput.value.slice(0, 2) + ":00:";
      return false;
    }

    if (intValidNum.length === 8 && intValidNum.slice(-2) > 60) {
      timeInput.value = timeInput.value.slice(0, 5) + ":";
      return false;
    }
    if (intValidNum.length === 8 && intValidNum.slice(-2) === 60) {
      timeInput.value = timeInput.value.slice(0, 5) + ":00";
      return false;
    }
  }
  const [page, setPage] = useState(0);
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = tatTests.links && tatTests.links.next.split("?")[1];
      getTatTests(`?${url}`);
    } else if (newPage < page) {
      let url = tatTests.links && tatTests.links.previous.split("?")[1];
      getTatTests(`?${url}`);
    }
    setPage(newPage as number);
  };
  useEffect(() => {
    let temp: any = [];
    tatTests.results &&
      tatTests.results.length > 0 &&
      tatTests.results.map((list: any) => {
        temp.push({
          id: list?.id || "",
          test_name: list?.package?.name || "",
          lab: list?.assigned_lab?.name || "",
          sample_runs_on: list?.days,
          processing_time_days:
            list?.tat_time_duration === null
              ? ""
              : list?.tat_time_duration.split(" ")[0],
          processing_time_hours:
            list?.tat_time_duration === null
              ? ""
              : list?.tat_time_duration.split(" ")[1],
        });
      });
    setTableData(temp);
  }, [tatTests]);

  // Here 2

  const updateItemValue = (
    key: string,
    index: number,
    value: any,
    item: any
  ) => {
    let tempTable = [...tableData];
    let newItem = item;
    switch (key) {
      case "processingTimeDays":
        newItem.processing_time_days = value;
        break;
      case "processingTimeHours":
        newItem.processing_time_hours = value;
        break;

      case "sampleRunsOn":
        const { name, checked } = value.target;
        if (checked) {
          newItem.sample_runs_on.push(Number(name));
        } else {
          const array: any = newItem.sample_runs_on;
          const index = array.indexOf(Number(name));
          if (index > -1) {
            array.splice(index, 1);
          }
          newItem.sample_runs_on = array;
        }
        break;
    }
    tempTable[index] = newItem;
    setTableData(tempTable);
  };

  const handleSubmitForm = async (val: any) => {
    const data = {
      tat_time_duration:
        val.processing_time_days + " " + val.processing_time_hours,
      days: val.sample_runs_on,
    };
    await updateTatTests(data, val.id);
    getTatTests(`?center=${centre}&lab=${lab}&test=${testId}`);
  };

  const searchHandle = () => {
    if (centre !== "" && lab !== "") {
      getTatTests(`?center=${centre}&lab=${lab}&test=${testId}`);
    }
  };
  const resethandler = () => {

    getTatTests(`?center=${centre}&lab=${lab}`)
    history.push("/dashboard/gnadmin/tat_master")}
  useEffect(() => {
    if (centre !== "" && lab !== "") {
      getTatTestsNames(`?center=${centre}&lab=${lab}`);
    }
  }, [centre, lab]);

  return (
    <div className={classes.root} style={{ padding: "20px 0" }}>
      <Grid container spacing={3} style={{ margin: "25px auto" }}>
        <Grid container item xs={12} className={classes.center}>
          <Typography
            variant="h4"
            component="h1"
            align="center"
            style={{ fontWeight: "bold" }}
          >
            TAT MASTER{" "}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid container spacing={3} item xs={12}>
          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              id="center"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setCentre(obj.id);
                }
              }}
              disabled={centerInfo?.results === undefined}
              freeSolo
              blurOnSelect
              options={centerInfo?.results || []}
              disableCloseOnSelect
              getOptionLabel={(option: any) =>
                (option?.display_name === null
                  ? option?.name
                  : option?.display_name) +
                "(" +
                option?.center_code +
                ")"
              }
              onInputChange={(event, newInputValue) => {
                getCenterInfo(`&name_or_code=${newInputValue}`);
                setCentreName(newInputValue);
              }}
              inputValue={centreName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hospital/Doctor"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setLab(obj.id);
                }
              }}
              onInputChange={(event, newInputValue) => {
                getLabCredential(`?name=${newInputValue}`);
                if (newInputValue.length === 0) {
                  setLab("");
                }
              }}
              options={labCredential?.results || []}
              freeSolo
              blurOnSelect
              aria-required
              getOptionLabel={(option: any) => `${option?.name}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Lab"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setTestId(obj.package?.id);
                }
              }}
              onInputChange={(event, newInputValue) => {
                getTatTestsNames(
                  `?center=${centre}&lab=${lab}&package_name=${newInputValue}`
                );
                if (newInputValue.length === 0) {
                  setTestId("");
                }
              }}
              options={tatTestsNames?.results || []}
              disabled={centre === "" && lab === ""}
              freeSolo
              blurOnSelect
              aria-required
              getOptionLabel={(option: any) =>
                option?.package?.name + "(" + option?.package?.code + ")"
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tests"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              style={{ height: "100%" }}
              onClick={searchHandle}
              disabled={centre === "" || lab === ""}
            >
              SEARCH
            </Button>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              color="primary"
              style={{ height: "56px" }}
              fullWidth
              onClick={() => resethandler()}
              >
                  Reset
            </Button>
          </Grid>
        </Grid>
        <Grid container xs={12} style={{ padding: "15px 0" }}>
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "540px" }}
          >
            {loading ? (
              <Loader />
            ) : (
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">
                      <b>Sr No</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <b>Test Name</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <b>Lab Name</b>
                    </StyledTableCell>

                    <StyledTableCell align="center" style={{ width: "300px" }}>
                      <b>Processing Time </b>
                      <StyledTableCell align="center" style={{ width: 150 }}>
                        <b>Days</b>
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ width: 150 }}>
                        <b> HH:MM:SS</b>
                      </StyledTableCell>
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ width: "420px" }}>
                      <b>Sample Runs On </b>
                      <StyledTableCell align="center">
                        <b>Sun</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Mon</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Tue</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Wed</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Thu</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Fri</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Sat</b>
                      </StyledTableCell>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <b>Update </b>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {tableData &&
                    tableData.length >= 0 &&
                    tableData?.map((val: any, index: any) => {
                      return (
                        <StyledTableRow>
                          <StyledTableCell align="center">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {val?.test_name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {val?.lab}
                          </StyledTableCell>
                          <StyledTableCell>
                            <StyledTableCell align="center">
                              <TextField
                                id="outlined-number"
                                type="number"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                value={val?.processing_time_days}
                                onChange={(e) =>
                                  updateItemValue(
                                    "processingTimeDays",
                                    index,
                                    e.target.value,
                                    val
                                  )
                                }
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <input
                                style={{ width: 63 }}
                                id="txtStartTime"
                                type="text"
                                placeholder={val?.processing_time_hours}
                                onKeyPress={(e) => formatTime(e.target)}
                                maxLength={8}
                                onChange={(e) =>
                                  updateItemValue(
                                    "processingTimeHours",
                                    index,
                                    e.target.value,
                                    val
                                  )
                                }
                              />
                            </StyledTableCell>
                          </StyledTableCell>
                          {/* Here 1 */}
                          <StyledTableCell align="center">
                            <Checkbox
                              style={{ margin: "0 6px" }}
                              name="1"
                              checked={val?.sample_runs_on.some((item: any) => {
                                return item === 1;
                              })}
                              onChange={(e) =>
                                updateItemValue("sampleRunsOn", index, e, val)
                              }
                            />
                            <Checkbox
                              style={{ margin: "0 6px" }}
                              name="2"
                              checked={val?.sample_runs_on.some((item: any) => {
                                return item === 2;
                              })}
                              onChange={(e) =>
                                updateItemValue("sampleRunsOn", index, e, val)
                              }
                            />
                            <Checkbox
                              style={{ margin: "0 6px" }}
                              name="3"
                              checked={val?.sample_runs_on.some((item: any) => {
                                return item === 3;
                              })}
                              onChange={(e) =>
                                updateItemValue("sampleRunsOn", index, e, val)
                              }
                            />
                            <Checkbox
                              style={{ margin: "0 6px" }}
                              name="4"
                              checked={val?.sample_runs_on.some((item: any) => {
                                return item === 4;
                              })}
                              onChange={(e) =>
                                updateItemValue("sampleRunsOn", index, e, val)
                              }
                            />
                            <Checkbox
                              style={{ margin: "0 6px" }}
                              name="5"
                              checked={val?.sample_runs_on.some((item: any) => {
                                return item === 5;
                              })}
                              onChange={(e) =>
                                updateItemValue("sampleRunsOn", index, e, val)
                              }
                            />
                            <Checkbox
                              style={{ margin: "0 6px" }}
                              name="6"
                              checked={val?.sample_runs_on.some((item: any) => {
                                return item === 6;
                              })}
                              onChange={(e) =>
                                updateItemValue("sampleRunsOn", index, e, val)
                              }
                            />
                            <Checkbox
                              style={{ margin: "0 6px" }}
                              name="7"
                              checked={val?.sample_runs_on.some((item: any) => {
                                return item === 7;
                              })}
                              onChange={(e) =>
                                updateItemValue("sampleRunsOn", index, e, val)
                              }
                            />
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <StyledTableCell align="center">
                              <Button
                                fullWidth
                                size="large"
                                variant="contained"
                                color="primary"
                                onClick={() => handleSubmitForm(val)}
                              >
                                update
                              </Button>
                            </StyledTableCell>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={tatTests.count}
                  rowsPerPage={tatTests.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </Table>
            )}
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  labCredential: state.GenomicsAdminReducer.labCredential,
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  tatTests: state.GenomicsAdminReducer.tatTests,
  tatTestsNames: state.GenomicsAdminReducer.tatTestsNames,
  loading: state.GenomicsAdminReducer.loading,
});

export default connect(mapStateToProps, {
  getTatTests,
  getLabCredential,
  updateTatTests,
  getCenterInfo,
  getTatTestsNames,
})(SampleRegistrationTATMaster);
